module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAIaGhgCZ/xVrmwhqnxZkmh1cjQxflghfkxJPgw5PgxdMfwpPhQZPgwJPgyJDbzM8YjUkAD0YDCQMABQQAD0AADEAAC0AACQAABwAABQABAwAAAQAAP///wAAAAAAAAAAACH5BAEHABwALAAAAAAgACAAAAXIICeOZGmeaGpu7Ka+K+nCcBME4t3Qqn3/Ot7JBwTuhCNi0YjkbGyNqJL5AlhZ0I3GolgGqy0b4tLqLp0vliXxW0Raj6JohmJRHMXCm2W+zVNhXgQTLBhKaCeBXgEHEhuGVCsbFwiLPwIQTz9HJlJ9lgFSX52gpZwlPlGlm1IoqVirBhUsda+wlgMtgEaKSw0tALu8GxlTocDBdb69AQm6HMmuy7cMzzTGDRdkWXQ82BSav00i2KnjSYun59jnpDrq7eRR3fH1JCEAOw=="


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadNE_S0.gif
// module id = 1A1O
// module chunks = 50